import { createSlice } from "@reduxjs/toolkit";

const tableExpaneder = createSlice({
  name: "tableExapneder",
  initialState: false,
  reducers: {
    setTableExapneder: (state, action) => {
      return action.payload;
    },
  },
});

export const { setTableExapneder } = tableExpaneder.actions;
export default tableExpaneder.reducer;
